import React, { Fragment } from 'react';
export function Navigation() {
  const links = ['HOME', 'ABOUT US', 'SHIPPING', 'TESTIMONIALS', 'SITE MAP', 'Careers', 'CONTACT US', 'MODEL CHARTS', 'PRIVACY POLICY'];
  return <nav className="bg-gray-800 border-b-4 border-gray-900" data-id="element-71">
      <div className="max-w-7xl mx-auto px-4" data-id="element-72">
        <div className="flex items-center justify-center gap-1 py-3 flex-wrap" data-id="element-73">
          {links.map((link, index) => <Fragment key={link} data-id="element-74">
              <a href="#" className="text-white text-sm font-medium hover:text-gray-300 px-2" data-id="element-75">
                {link}
              </a>
              {index < links.length - 1 && <span className="text-white" data-id="element-76">|</span>}
            </Fragment>)}
        </div>
      </div>
    </nav>;
}